export const resetMediaEditor = () => ({
  type: "RESET_MEDIA_EDITOR"
});

export const setMediaEditor = mediaEditor => ({
  type: "SET_MEDIA_EDITOR",
  mediaEditor
});



// WEBPACK FOOTER //
// ./src/actions/actions/media-editor.js